import get from 'lodash/get';

export const selectWorkspaceSaved = (state) => get(state, 'workspaceEditCreate.workspaceSaved', false);
export const selectWsEditCreateName = (state) => get(state, 'workspaceEditCreate.name', '');
export const selectWsEditCreateDescription = (state) => get(state, 'workspaceEditCreate.description', '');
export const selectWsEditCreateStart = (state) => get(state, 'workspaceEditCreate.start', '');
export const selectWsEditCreateEnd = (state) => get(state, 'workspaceEditCreate.end', '');
export const selectWsEditCreateLocale = (state) => get(state, 'locale', '');
export const selectWsEditCreateErrorMessage = (state) => get(state, 'workspaceEditCreate.errorMessage', '');
export const selectWsEditCreateId = (state) => get(state, 'workspaceEditCreate.id');
export const selectCurrentWsName = (state) => get(state, 'workspaceEditCreate.currentName', '');
export const selectWsEditCreateMakePublic = (state) => get(state, 'workspaceEditCreate.public', false);
export const selectWsEditCreateCurrentUsers = (state) => {
  const wsUsers = get(state, 'workspaceEditCreate.users', []);
  const currentActiveUsers = wsUsers.filter((user) => !user.includes('DELETED_USER_'));
  return currentActiveUsers;
};
export const selectIsFetching = (state) => get(state, 'workspaceEditCreate.isFetching', false);
export const selectScope = (state) => get(state, 'workspaceEditCreate.scope', []);
export const selectWsEditActive = (state) => get(state, 'workspaceEditCreate.active', false);
export const selectWsEditCustomer = (state) => get(state, 'workspaceEditCreate.customer', '');
export const selectWsEditGroupBy = (state) => get(state, 'workspaceEditCreate.groupby', 'none');
export const selectWsEditGroupByMatchPrecision = (state) => get(state, 'workspaceEditCreate.matchPrecision', 80);
export const selectWsEditGroupByAlgorithm = (state) => get(state, 'workspaceEditCreate.groupAlgorithm', 'levenshtein');
export const selectWsEditReadonly = (state) => get(state, 'workspaceEditCreate.readonly', true);
export const selectWsEditCreateImportance = (state) => get(state, 'workspaceEditCreate.importance', 0);
export const selectWsEditRiskScoreProfile = (state) => get(state, 'workspaceEditCreate.riskScoreProfile', null);

export const selectPendingWorkspaceUpdate = (state) =>
  state.workspaceEditCreate?.pendingWorkspaceUpdate;

export const selectShowGroupingConfirm = (state) =>
  state.workspaceEditCreate?.showGroupingConfirm;
